module.exports = __webpack_public_path__ + "img/racecourse-mauritius-turf-2200.876ae5f7.svg";